import { Alert, Form, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { attemptGetOrder, Order } from '../../utils/redux/ordersSlice'
import { listenerMiddleware, store, useAppDispatch, useAppSelector } from '../../utils/redux/store'
import ClientRequest from './ClientRequest'
import { useEffect, useState } from 'react'
import { useAttemptListener } from 'dev-masters-react-kit'

interface Props {}

interface Params extends Record<string, string> {
  id: string
}

export default function ManageOrder({}: Props) {
  const { id: orderId } = useParams<Params>()
  const order = useAppSelector((state) => state.orders.orders[orderId || ''])
  const dispatch = useAppDispatch()
  const [pending, setPending] = useState(false)

  useEffect(() => {
    if (!order && orderId) {
      dispatch(attemptGetOrder(orderId))
    }
  }, [])

  useAttemptListener({
    attempt: attemptGetOrder,
    listenerMiddleware: listenerMiddleware,

    onFulfilled: () => {
      setPending(false)
    },
    onPending: () => {
      setPending(true)
    },
    onRejected: () => {
      setPending(false)
    }
  })

  return (
    <div className="content">
      {order ? (
        <ClientRequest order={order}/>
      ): (
        pending ? (
          <Spin size="large" />
        ): (
          <Alert message="Order not found" type="error" showIcon />
        )
      )}
    </div>
  )
}
